// @owners { team: patients }
import { type LightDelivery } from '~shared/types';

export const getDeliveryEstimatedPrice = (delivery: LightDelivery | undefined) => {
  // only show estimated prices when a delivery is in data check and has been billed successfully
  return delivery && delivery.billing_status === 'billed' && delivery.internal_status === 'data_check'
    ? delivery.patient_paid
    : undefined;
};
